var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Gadget } from '../libs/gadgets.class';
var DefaultPanel = /** @class */ (function (_super) {
    __extends(DefaultPanel, _super);
    function DefaultPanel(title, id, overflow) {
        if (id === void 0) { id = ""; }
        if (overflow === void 0) { overflow = false; }
        var _this = _super.call(this) || this;
        _this.title = "";
        _this.id = "";
        _this.overflow = false;
        _this.allow_expand = true;
        _this.title = title;
        _this.id = id;
        _this.overflow = overflow;
        return _this;
    }
    DefaultPanel.prototype.disableExpand = function () {
        this.allow_expand = false;
    };
    DefaultPanel.prototype.render = function (forceParseGadgets) {
        if (this.getHtml() == "")
            this.parseGadgets();
        var _s = "data-sortable=\"false\"";
        var expand_string = this.allow_expand ? "<a href=\"javascript:;\" class=\"btn btn-xs btn-icon btn-default\" data-toggle=\"panel-expand\"><i class=\"fa fa-expand\" style=\"margin-top:0px\"></i></a>" : '';
        if (this.id != "")
            _s += "id=\"".concat(this.id, "\" ");
        return "<div ".concat(_s, " class=\"panel panel-inverse\"><div class=\"panel-heading\"><h4 class=\"panel-title\">").concat(this.title, "</h4><div class=\"panel-heading-btn\">").concat(expand_string, "</div></div><div class=\"panel-body ").concat(this.overflow ? 'overflow-auto' : '', "\">").concat(this.getHtml(), "</div></div>");
    };
    return DefaultPanel;
}(Gadget));
export { DefaultPanel };
